<template>
  <v-btn
    text
    small
    class="text-none px-0"
    color="primary"
    @click="$router.back()"
  >
    <v-icon
      dense
      class="mr-1"
    >
      mdi-arrow-left
    </v-icon>
    {{ $t('Back') }}
  </v-btn>
</template>

<script>
    export default {
        name: "Back",
    }
</script>

<style scoped>

</style>
